/* eslint-disable jira/naming/disallow-filenames */
import React from 'react';
import type PolarisUnlicensedPageType from '@jira/spa-apps__polaris-unlicensed/src/index.tsx';
import { markAsProductBundleReady } from '@jira/platform__spa/src/services/mark-as-product-bundle-ready/index.tsx';
import { LazyPage } from '@jira/platform__spa/src/view/lazy-page/index.tsx';
import { lazyForPaint, type LazyComponent } from '@atlassian/react-loosely-lazy';

// This will be migrated with the other JPD pages.

export const LazyUnlicensedPage: LazyComponent<{
	// oxlint-disable-next-line @typescript-eslint/no-explicit-any
	(props: Record<string, any>): React.JSX.Element;
	displayName: string;
}> = // eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
	lazyForPaint<typeof PolarisUnlicensedPageType>(
		() =>
			markAsProductBundleReady(
				import(
					/* webpackChunkName: "async-polaris-unlicensed", jiraSpaEntry: "async-polaris-ideas" */ '@jira/spa-apps__polaris-unlicensed/src/index.tsx'
				),
			),
		{ ssr: false },
	);

const AsyncUnlicensedPage = (): React.JSX.Element => (
	<LazyPage Page={LazyUnlicensedPage} pageId="async-polaris-unlicensed" shouldShowSpinner={false} />
);

export default AsyncUnlicensedPage;
